import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import { DashboardSearchProps } from "../../../../domain/repositories/dashboard.repository";
import DateDto from "../../../dto/date.dto";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const getAveragesScorePerWeekApiImpl = async (_: DashboardSearchProps): Promise<Either<ErrorEntity, { week: string; score: number; }[]>> => {
    try {
        let relativeUrl = "/stats/average-score-per-week?";
        const { startDate, endDate, aiAgentId, callTypeId, humanAgentId, operationId }: { startDate: Date, endDate: Date, operationId?: string, humanAgentId?: string, aiAgentId?: string, callTypeId?: string, } = _;
        if (startDate) relativeUrl += `start_date=${DateDto.toServer(startDate)}&`
        if (endDate) relativeUrl += `end_date=${DateDto.toServer(endDate)}&`
        if (aiAgentId) relativeUrl += `agent_id=${aiAgentId}&`
        if (callTypeId) relativeUrl += `call_type=${callTypeId}&`
        if (humanAgentId) relativeUrl += `human_agent_id=${humanAgentId}&`
        if (operationId) relativeUrl += `operation_id=${operationId}&`
        relativeUrl = relativeUrl.slice(0, -1); // remove the last '&'
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl, {
            contentType: 'application/json',
        });
        console.log("getAveragesScorePerWeekApiImpl", response);
        const parsed = response.sort((a: any, b: any) => a.week_number - b.week_number).map((item: any) => {
            return {
                week: item.week_start_date,
                score: item.avg_total_score,
            }
        });
        return right(parsed);
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default getAveragesScorePerWeekApiImpl;